'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWeatherNight = function TiWeatherNight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 33.3c-1.4 0-2.8-0.2-4.2-0.7l-2.2-0.8 1.5-1.8c2.1-2.6 3.2-5.8 3.2-9.2s-1.1-6.5-3.2-9.1l-1.5-1.8 2.2-0.8c1.4-0.5 2.8-0.8 4.2-0.8 6.9 0 12.5 5.6 12.5 12.5s-5.6 12.5-12.5 12.5z m-0.8-3.3c0.2 0 0.5 0 0.8 0 5.1 0 9.2-4.1 9.2-9.2s-4.1-9.1-9.2-9.1c-0.3 0-0.6 0-0.8 0 1.6 2.7 2.5 5.9 2.5 9.1s-0.9 6.4-2.5 9.2z' })
        )
    );
};

exports.default = TiWeatherNight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/weather-night.js
// module id = 3281
// module chunks = 0